<form class="formLocation" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="outline" color="accent" class="input-margin">
    <mat-label>Localisation</mat-label>
    <input matInput required formControlName="localisationLabel" type="text" maxlength="150" [errorStateMatcher]="matcher"/>
    <mat-hint>Obligatoire</mat-hint>
    <mat-hint align="end"> {{ (formGroup.get('localisationLabel')?.value?.length || 0) + '/150 caractères' }}
    </mat-hint>

    <mat-error *ngIf="formGroup.get('localisationLabel')?.errors?.['required']">
      La localisation est obligatoire
    </mat-error>
    <mat-error *ngIf="formGroup.get('localisationLabel')?.errors?.['pattern']">
      La localisation doit contenir au moins un caractère non numérique et maximum 3 chiffres
    </mat-error>
    <mat-error *ngIf="formGroup.get('localisationLabel')?.errors?.['maxlength']">
      Maximum 150 caractères
    </mat-error>
    <mat-error *ngIf="errorMessage && !formGroup.get('localisationLabel')?.errors">
      {{ errorMessage }}
    </mat-error>

  </mat-form-field>

  <button mat-raised-button class="btn_created" color="primary" type="submit" [disabled]="!formGroup.valid"
    *ngIf="!isEditMode">
    Créer
  </button>
  <button mat-raised-button class="btn_annuler" type="button" color="accent" (click)="clear()">
    Annuler
  </button>
  <button mat-raised-button class="btn_valid" type="submit" [disabled]="!formGroup.valid" *ngIf="isEditMode">
    Modifier
  </button>
</form>